import React, { useState, memo, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { resetScroll } from '../../utilities/browserUtilities';
import MyVideosIcon from '@mui/icons-material/SubscriptionsRounded';
import PlanIcon from '@mui/icons-material/ViewWeekRounded';
import AccountIcon from '@mui/icons-material/PersonRounded';

import { makeStyles } from 'tss-react/mui';
import { AppBar } from '@mui/material';


const useStyles = makeStyles()((theme) => ({
    footerNavigation: {
        width: '100%',
        height: '65px',
        position: 'fixed',
        bottom: 0,
        zIndex: 1000
    },
    navigationLabel: {
        margin: '5px 0'
    },
    footerNavigationButton: {
        color: "#fff"
    }
}));

const navigationItems = ['/plans', '/account', "/videos"];

const MobileMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeNavigationItem, setActiveNavigationItem] = useState(location.pathname);
    const { classes } = useStyles();

    useEffect(() => {
        if (navigationItems.includes(location.pathname))
            setActiveNavigationItem(location.pathname)
    }, [location.pathname])

    const onPageChange = (event, url) => {
        setActiveNavigationItem(url);
        navigate(url);
        resetScroll();
    };

    return (
        <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }}>
            <BottomNavigation
                value={activeNavigationItem}
                showLabels
                onChange={onPageChange}
                className={classes.footerNavigation}
            >
                <BottomNavigationAction
                    value={"/plans"}
                    label="Plans"
                    icon={<PlanIcon />}
                    classes={{ label: classes.navigationLabel }}
                    className={classes.footerNavigationButton}
                />
                <BottomNavigationAction
                    value={"/videos"}
                    label="My Videos"
                    icon={<MyVideosIcon />}
                    classes={{ label: classes.navigationLabel }}
                    className={classes.footerNavigationButton}
                />
                <BottomNavigationAction
                    value={"/account"}
                    label="Account"
                    icon={<AccountIcon />}
                    classes={{ label: classes.navigationLabel }}
                    className={classes.footerNavigationButton}
                />

            </BottomNavigation>
        </AppBar>
    );
}

export default memo(MobileMenu);